import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.2668 3V7.66667M13.7335 3V7.66667M4.40013 5.33333H15.6001C16.1156 5.33333 16.5335 5.7512 16.5335 6.26667V15.6C16.5335 16.1155 16.1156 16.5333 15.6001 16.5333H4.40013C3.88466 16.5333 3.4668 16.1155 3.4668 15.6V6.26667C3.4668 5.7512 3.88466 5.33333 4.40013 5.33333Z",
  stroke: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "calendar",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})